import Cookie from 'js-cookie';
import queryString from 'query-string';
import Track from '@utils/track';
import { isbot } from 'isbot';

export const saveExternalLinkTracking = (inviteCode) => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObj = {};
  let hasUtmParam = false;

  if(urlParams.has('af_xp')) {
    return "referral";
  }

  if (inviteCode) {
    paramsObj.invite_code = inviteCode;
  }

  urlParams.forEach((value, key) => {
    paramsObj[key] = value;

    if (key.startsWith('utm_')) {
      hasUtmParam = true;
    }
  });

  if (!hasUtmParam) {
    return;
  }

  if (isbot(navigator.userAgent)) {
    return;
  }

  Track.externalLinkClick({
    params: paramsObj
  });
}

export const saveUtmsToCookie = () => {
  const params = queryString.parse(location.search);

  if (params.utm_source) {
    Cookie.set('utm_source', params.utm_source.toLowerCase());
  } else if (params.source) {
    Cookie.set('utm_source', params.source.toLowerCase());
  }

  if (params.utm_medium) {
    Cookie.set('utm_medium', params.utm_medium.toLowerCase());
  }

  if (params.utm_campaign) {
    Cookie.set('utm_campaign', params.utm_campaign.toLowerCase());
  }

  if (params.utm_content) {
    Cookie.set('utm_content', params.utm_content.toLowerCase());
  }

  if (document.referrer) {
    const existingValue = Cookie.get('external_referrer')
    if (existingValue) {
      return;
    }
    if (document.referrer.startsWith("https://benable.com/")) {
      return;
    }
    Cookie.set('external_referrer', document.referrer);
  }
};